import { NotesForm } from 'components';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../MenuItem';

type NotesMenuProps = {
  className?: string;
};

export function NotesMenu({ className }: NotesMenuProps): JSX.Element {
  const { t } = useTranslation('providerRoom');

  return (
    <>
      <MenuItem className={className} title={t('menus.notes')}>
        <NotesForm />
      </MenuItem>
    </>
  );
}
